import Swiper, {Navigation} from 'swiper';

const promotionsSliders = [...document.querySelectorAll('.j-slider-promotions')];

promotionsSliders.forEach((promotionsSlider) => {
    const slider = new Swiper(promotionsSlider, {
        modules         : [Navigation],
        wrapperClass    : 'j-slider-promotions__wrapper',
        slideClass      : 'j-slider-promotions__slide',
        slideActiveClass: 'is-active',
        slideNextClass  : 'is-next',
        slidesPerView   : 'auto',
        breakpoints     : {
            1280: {
                slidesPerView: 1
            }
        },
        navigation: {
            prevEl       : '.j-slider-promotions__arr-prev',
            nextEl       : '.j-slider-promotions__arr-next',
            disabledClass: 'is-disabled'
        }
    });

    if (slider.slides.length === 1) {
        slider.navigation.nextEl.style.display = 'none';
        slider.navigation.prevEl.style.display = 'none';
    }

    return slider;
});
